import { Tenant } from '@/types/common';

import { isCaymanDomain } from '@/utils/domain';

export const DEFAULT_TENANT = isCaymanDomain ? Tenant.Cayman : Tenant.BVI;
